import type { TThreshold } from '@timeedit/types';
import { InputNumber, Space } from '@timeedit/ui-components/antd';
import { LabelWrapper } from '@timeedit/ui-components/components/InputComponent/Input';

type Props = {
  threshold?: TThreshold;
  onChange: (value: TThreshold) => void;
  label: string;
};

const Threshold = ({ threshold, onChange, label }: Props) => {
  return (
    <LabelWrapper label={label} tooltip="Low - Target - High">
      <Space direction="horizontal">
        <InputNumber
          min={0}
          max={100}
          size="small"
          placeholder="Low"
          style={{ width: 'fit-content' }}
          value={threshold?.low}
          onChange={(val) => onChange({ ...threshold, low: val })}
        />
        <InputNumber
          min={0}
          max={100}
          size="small"
          placeholder="Target"
          style={{ width: 'fit-content' }}
          value={threshold?.target}
          onChange={(val) => onChange({ ...threshold, target: val })}
        />
        <InputNumber
          min={0}
          max={100}
          size="small"
          placeholder="High"
          style={{ width: 'fit-content' }}
          value={threshold?.high}
          onChange={(val) => onChange({ ...threshold, high: val })}
        />
      </Space>
    </LabelWrapper>
  );
};

export default Threshold;
